export default {
    created: "Lista de destinatari WhatsApp a fost creata cu succes.",
    updated: "Lista de destinatari WhatsApp a fost actualizata cu succes.",
    deleted: "Lista de destinatari WhatsApp a fost stearsa cu succes.",
    restored: "Lista de destinatari WhatsApp a fost restaurata cu succes.",
}
